webpackJsonp([184885863265800],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/participate.json":
/***/ (function(module, exports) {

	module.exports = {"data":{"allContentfulParticipate":{"edges":[{"node":{"id":"c4OFDztMove2kW0ioAYGQsK","participateTitle":"Sign up with Contraline","participateBody":{"participateBody":"We'd love to hear your interest in potentially participating in our clinical trials."},"physicianText":{"physicianText":"Let us know if you'd like to be involved in the trials for our male contraceptive products."},"menText":{"menText":"Sign up here if you or your partner are considering being part of a male contraceptive trial."},"leftButtonText":"Men and Couples","rightButtonText":"Physicians"}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---participate-adb194d3b7ddf35f76a2.js